import { render } from "./Residents.vue?vue&type=template&id=556e43b1&scoped=true"
import script from "./Residents.vue?vue&type=script&lang=js"
export * from "./Residents.vue?vue&type=script&lang=js"

import "./Residents.vue?vue&type=style&index=0&id=556e43b1&scoped=true&lang=css"

import exportComponent from "/Users/akiowatanabe/work_space/secure_link/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556e43b1"]])

export default __exports__